/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services  {
   export class ApiKeyService {
       public constructor(
           private $q: angular.IQService,
           private $http: angular.IHttpService) {

       }

       public addKey(name:string): angular.IPromise<Wars.Domain.Model.ApiKey> {
           var d = this.$q.defer();

           this.$http.post('./api/ApiKey/' + name, null).then(r => {
               d.resolve(r.data);
           });

           return d.promise; 
       }

       public getKeys():angular.IPromise<Wars.Domain.Model.ApiKey[]> {
           var d = this.$q.defer();

           this.$http.get('./api/ApiKey/').then(r => {
               d.resolve(r.data);
           });

           return d.promise;
       }

       public updateKey(apiKey: Wars.Domain.Model.ApiKey):angular.IPromise<any> {
           return this.$http.post('./api/ApiKey/Update', apiKey);
       }
   } 
}

warsApp.registerService('ApiKeyService', ['$q', '$http']);